<template>
  <div class="wrapper" :class="{ mobile: !isLargeScreen }">
    <div
      class="firing-alerts"
      :class="{ warning: !!firingAlertsAmountOfSelectedASN }"
    >
      <div class="title">
        <fa
          :icon="
            !!firingAlertsAmountOfSelectedASN
              ? 'exclamation-triangle'
              : 'check-circle'
          "
        ></fa>
        <h5 v-if="!isMobile">
          {{
            !!firingAlertsAmountOfSelectedASN
              ? 'You have firing alerts'
              : 'No firing alerts'
          }}
        </h5>
        <h5 v-else>
          {{
            !!firingAlertsAmountOfSelectedASN
              ? 'Firing alerts'
              : 'No firing alerts'
          }}
        </h5>
      </div>
      <p v-if="!!firingAlertsAmountOfSelectedASN" class="number">
        {{ firingAlertsAmountOfSelectedASN }}
      </p>
    </div>
    <div class="last-firing-alert">
      <div class="title">
        <h5>
          Last firing alert
        </h5>
        <span>(last 7 days)</span>
      </div>
      <div v-if="!lastFiringAlertObj || !lastFiringAlertObj.name">
        No firing alert in the last 7 days.
      </div>
      <div v-else>
        <div class="description-wrapper">
          <h6>Alert name:</h6>
          <span class="truncated">{{ lastFiringAlertObj.name }}</span>
        </div>
        <div class="description-wrapper">
          <h6>Date:</h6>
          <span>{{ lastFiringAlertObj.datetime | dateFormatter }}</span>
        </div>
        <div class="description-wrapper">
          <h6>Trigger:</h6>
          <span>{{ lastFiringAlertObj.trigger }}</span>
        </div>
        <div class="description-wrapper">
          <h6>Incident:</h6>
          <span>{{ lastFiringAlertObj.reason }}</span>
        </div>
        <div class="expand-alert">
          <span @click="expandAlert(lastFiringAlertObj.id)">
            More details
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
export default {
  name: 'FiringAlertsCard',
  props: {
    firingAlertsAmountOfSelectedASN: {
      type: Number,
      required: true
    },
    lastFiringAlertObj: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isLargeScreen', 'isMobile']),
    ...mapState('alertsSuspiciousTrafficStore', ['searchQuery'])
  },
  methods: {
    ...mapMutations('alertsSuspiciousTrafficStore', [
      'setSearchQuery',
      'setExpandedAlertId'
    ]),

    expandAlert(alertId) {
      if (this.searchQuery) {
        // If searchQuery exists, clear it first. Otherwise the last firing alert may not in the filtered alert list.
        this.setSearchQuery('');

        // Use setTimeout to allow the filtered alert list to be refreshed. Otherwise the last firing alert may not in the filtered alert list.
        setTimeout(() => {
          this.setExpandedAlertId(alertId);
        }, 500);
      } else {
        this.setExpandedAlertId(alertId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 1.5rem;
  width: 100%;
  background-color: #ffffff;
}

.firing-alerts {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid $border-grey;
  color: #208836;

  &.warning {
    color: $warning-red;
  }

  .title {
    h5 {
      font-size: 1.125rem;
      display: inline-block;
      padding-left: 1rem;
      margin: 0;
      color: inherit;
    }
    span {
      display: inline-block;
      font-size: 1rem;
      font-weight: 400;
      text-indent: 0.5rem;
    }
    svg {
      font-size: 1.25rem;
    }
  }

  .number {
    font-size: 2.5rem;
    margin: 0;
    color: inherit;
  }
}

.last-firing-alert {
  .title {
    h5 {
      font-size: 1.125rem;
      margin-bottom: 1rem;
      display: inline-block;
    }
    span {
      display: inline-block;
      font-size: 1rem;
      font-weight: 400;
      text-indent: 0.5rem;
    }
  }

  .description-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 0.75rem;

    h6 {
      margin-bottom: 0;
      margin-right: 0.5rem;
    }
  }

  .expand-alert {
    margin-top: 0.5rem;

    text-align: right;
    color: $text-light-blue;

    span {
      padding: 0 0.5rem;
      cursor: pointer;
    }
  }
}

.mobile {
  .wrapper {
    padding: 1.5rem 1rem;
  }

  .firing-alerts {
    align-items: center;
    padding-bottom: 1.5rem;

    .title {
      h5 {
        margin-bottom: 0;
      }

      span {
        display: inline-block;
      }
    }
  }

  .last-firing-alert {
    .title {
      h5 {
        margin-bottom: 0.5rem;
      }

      span {
        display: inline-block;
      }
    }
  }

  p {
    margin-bottom: 0;
  }

  .number {
    margin-right: 0.5rem;
  }
}
</style>
